import React from 'react';
import { Link } from 'react-router-dom';
import AppDownloadSection from '../../components/AppDownloadSection/AppDownloadSection';
import {
  FaMotorcycle,
  FaStore,
  FaUtensils,
  FaUsers,
  FaCalendarAlt,
  FaUniversity,
  FaHospital,
  FaMobileAlt,
  FaConciergeBell,
  FaBoxOpen,
} from 'react-icons/fa';
import { MdDevices } from 'react-icons/md';
import './Services.css';

const services = [
  {
    icon: <FaMotorcycle />,
    title: 'FAST DELIVERY',
    desc: 'Hot, fresh meals delivered to your doorstep—right now, later, or even late at night where available.',
  },
  {
    icon: <FaStore />,
    title: 'PICKUP IN STORE',
    desc: 'Prefer to grab your meal yourself? Pre-order online and pick it up from our kitchen or partner locations with ease.',
  },
  {
    icon: <FaUtensils />,
    title: 'MEAL SERVICES',
    desc: 'Delicious breakfast, lunch, and dinner, available for online order with timely delivery.',
  },
  {
    icon: <FaUsers />,
    title: 'GROUP OR PARTY ORDER',
    desc: 'Let everyone order together, making office lunches, birthdays, celebrations, college groups, and events simple and hassle-free.',
  },
  {
    icon: <MdDevices />,
    title: 'Software and Services',
    desc: 'We provide software to run restaurants and cloud kitchens, along with IT services tailored to support day-to-day operations and growth.',
  },
  {
    icon: <FaCalendarAlt />,
    title: 'SUBSCRIPTIONS & MEAL PLANS',
    desc: 'Daily, weekly, monthly, or select-days meals—fresh, delicious, and delivered on your schedule.',
  },
  {
    icon: <FaUniversity />,
    title: 'INSTITUTIONAL CATERING',
    desc: 'Healthy, balanced meals approved by dietitians and nutritionists, for offices, schools, colleges, and institutions.',
  },
  {
    icon: <FaHospital />,
    title: 'HOSPITAL CATERING',
    desc: "Organic, hygienic, and fully customizable meals tailored to patients' medical needs and approved by healthcare professionals.",
  },
];

const Services = () => {
  return (
    <div className="services-page">
      {/* Page Header */}
      <div className="page-header">
        <div className="page-header-content">
          <div className="container">
            <h1>SERVICES</h1>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Services</span>
            </div>
          </div>
        </div>
      </div>

      {/* Services Grid */}
      <section className="services-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Best Services</span>
            <h2 className="section-title">
              WE&apos;VE GOT YOU <span>COVERED!</span>
            </h2>
            <p className="section-desc">
              At Digirasa, we bring delicious, healthy, and customized meals straight to you.
              Explore our wide range of services designed for convenience, quality, and nutrition.
            </p>
          </div>
          <div className="services-grid">
            {services.map((service, i) => (
              <div key={i} className="service-card">
                <div className="service-card__icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Best Food CTA */}
      <section className="services-cta">
        <div className="container">
          <div className="services-cta__content">
            <h2 className="section-title">
              THE BEST FOOD YOU WILL <span>EVER FIND!</span>
            </h2>
            <Link to="/our-menu" className="btn-primary">
              GO TO MENU
            </Link>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Simple Process</span>
            <h2 className="section-title">
              HOW IT <span>WORKS</span>
            </h2>
            <p className="section-desc">
              Getting fresh, healthy food from Digirasa to your door takes just three simple steps.
            </p>
          </div>
          <div className="how-it-works__steps">
            <div className="how-step">
              <div className="how-step__number">01</div>
              <div className="how-step__icon">
                <FaMobileAlt />
              </div>
              <h3>PLACE YOUR ORDER</h3>
              <p>
                Browse our menu on the Digirasa app or website. Select your meals, choose a delivery
                slot, and pay securely in seconds.
              </p>
            </div>
            <div className="how-step__connector" />
            <div className="how-step">
              <div className="how-step__number">02</div>
              <div className="how-step__icon">
                <FaConciergeBell />
              </div>
              <h3>WE PREPARE IT FRESH</h3>
              <p>
                Our kitchen team prepares your order fresh with quality ingredients, strict hygiene
                standards, and care — just like home.
              </p>
            </div>
            <div className="how-step__connector" />
            <div className="how-step">
              <div className="how-step__number">03</div>
              <div className="how-step__icon">
                <FaBoxOpen />
              </div>
              <h3>DELIVERED TO YOUR DOOR</h3>
              <p>
                Your meal is packed hygienically and delivered hot to your doorstep. Track your
                order live through the app at every step.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* App Download */}
      <AppDownloadSection />
    </div>
  );
};

export default Services;
